export default values => ({
  ...values,
  name: values.name || '',
  paternalName: values.paternalName || '',
  maternalName: values.maternalName || '',
  phone: values.phone || '',
  email: values.email || '',
  nationality: values.nationality || 'MX',
  kinship: values.kinship || ''
});
